export const FAST = 1;
export const REGULAR = 2;



// WEBPACK FOOTER //
// ./js/constants/JoinType.js